import React from 'react';

const CardTitle = ({className, onClick, children}) => {
    return (
        <h4 className={["bg-transparent font-semibold text-[#676a6c]", className].join(" ")} onClick={onClick}>
            {children}
        </h4>
    );
};

export default CardTitle;